
<template>
  <v-card
    :outlined="border"
    :elevation="border ? 2 : 0"
  >
    <v-card-title>
      {{ label }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <textarea
            name="input-7-1"
            :rows="rows"
            :disabled="disabled"
            v-model="html"
            @keyup="emitNewVal"
            class="html-editor"
          ></textarea>
        </v-col>
        <v-col
          cols="12"
          :md="6"
        >
          <v-card
            class="renderCard"
            outlined
            v-if="html"
          >
            <object
              class="objectHTML"
              type="text/html"
              :data="htmlPreview(html)"
            ></object>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
     

<script>
export default {
  name: "my-html-editor",
  props: {
    value: undefined,
    label: null,
    border: true,
    rows: {
      type: Number,
      default: 15,
    },
    disabled: false,
  },
  data() {
    return {
      html: null,
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      // watch it
      if (newVal) {
        this.html = newVal;
      } else this.html = this.value;
    },
  },
  mounted() {
    if (this.value) this.html = this.value;
    else this.html = "";
  },
  methods: {
    htmlPreview(html) {
      return "data:text/html;base64," + btoa(html);
    },
    emitNewVal(elem) {
      this.$emit("input", this.html);
    },
  },
};
</script>
<style>
.objectHTML {
  width: 100%;
  height: 100%;
}
.renderCard {
  height: 100%;
  top: 0px;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.html-editor {
  padding: 0px;
  margin: 0px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  font-family: "Courier New", monospace;
  line-height: 14px;
  color: #d0dc90 !important;
  background-color: #1e1e1e;
  border-radius: 5px;
}

.aspect-ratio {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 51%;
}
.aspect-ratio .objectHTML {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>